module.exports = __webpack_public_path__ + "static/nioxin.eb28aa4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nioxin.png
// module id = 468
// module chunks = 233015634327247